import { render, staticRenderFns } from "./wechat_login.vue?vue&type=template&id=62e0e1eb"
import script from "./wechat_login.vue?vue&type=script&lang=js"
export * from "./wechat_login.vue?vue&type=script&lang=js"
import style0 from "./wechat_login.vue?vue&type=style&index=0&id=62e0e1eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports